import React from 'react';
import { prefix } from '.';
import Icon, { IconType } from '@/components/Icon';

interface SkeletonProps {
  onLeftClick: () => void;
}

const Skeleton: React.FC<SkeletonProps> = props => {
  const { onLeftClick } = props;
  return (
    <div className={`${prefix}-skeleton`}>
      <div className="skeleton-bm-c-dining">
        <div className="skeleton-icon">
          <Icon className="circle-back-icon-outlined" type={IconType.LEFT_OUTLINED} onClick={onLeftClick} />
        </div>
      </div>
      <div className="skeleton-page-content">
        <div className="skeleton-main">
          <div className="skeleton-top1"></div>
          <div className="skeleton-top2"></div>
          <div className="skeleton-top3">
            <div></div>
          </div>
          <div className="skeleton-ds-content">
            <div className="skeleton-order-tip"></div>
            <div className="skeleton-buttons"></div>
          </div>
          <div className="skeleton-shipping-method">
            <div></div>
            <div></div>
          </div>
          <div className="skeleton-content">
            <div className="skeleton-listings-item">
              <div className="item-icon-wrapper1"></div>
              <div className="item-icon-wrapper2">
                <div className="wrapper2-1"></div>
                <div className="wrapper2-2"></div>
                <div className="wrapper2-3"></div>
              </div>
              <div className="item-icon-wrapper3"></div>
            </div>
            <div className="skeleton-listings-item">
              <div className="item-icon-wrapper1"></div>
              <div className="item-icon-wrapper2">
                <div className="wrapper2-1"></div>
                <div className="wrapper2-2"></div>
                <div className="wrapper2-3"></div>
              </div>
              <div className="item-icon-wrapper3"></div>
            </div>
            <div className="line">
              <div></div>
              <div></div>
            </div>
            <div className="line-total">
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="skeleton-transaction">
            <div className="skeleton-line1">
              <div></div>
              <div></div>
            </div>
            <div className="skeleton-line2">
              <div></div>
              <div></div>
            </div>
            <div className="skeleton-line3">
              <div></div>
              <div></div>
            </div>
            <div className="skeleton-line4">
              <div></div>
              <div></div>
            </div>
            <div className="skeleton-line3">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}
export default Skeleton;
